module.exports = __webpack_public_path__ + "img/warn_img.d835c591.png";